module.exports = __webpack_public_path__ + "page_3_swiper_bc.0470b27e.png";